import { useState, useEffect } from 'react'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { useMutation} from '@apollo/client';
import { DASHBOARD_SEND_PHONE_VERIFICATION, DASHBOARD_CHANGE_PHONE} from 'graphql/service';
import { userInfoState} from 'states/CheckOutStates/atoms'
import { useAuth } from 'customHooks/useAuth';

/**
 * A custom hook for Personal details Phone number Screen to change phone number
 */


export const useChangePhone = () => {

  const debug = false;
  
  
  const { refreshUserInfo } = useAuth();


  useEffect(() => {
    refreshUserInfo();
  }, [refreshUserInfo]);

  const setUserInfo = useSetRecoilState(userInfoState);
  const userInfo = useRecoilValue(userInfoState);

  if (debug) {
    console.log ("userInfo from useChangePhone", userInfo);
  }
  
  const [changePhoneErrorState, setChangePhoneErrorState] = useState({
    hasError: false,
    message: ''
  });


  const [changePhoneSuscessState, setChangePhoneSuscessState] = useState({
    isSuscess: false,
    message: 'Phone was successfully changed.',
  });


  const [sendPhoneVerificationErrorState, setSendPhoneVerificationErrorState] = useState({
    hasError: false,
    message: '',
    code: ''
  });


  const [sendPhoneVerificationSuscessState, setSendPhoneVerificationSuscessState] = useState({
    isSuscess: false,
    message: '',
  });


  const [sendPhoneVerification] = useMutation(DASHBOARD_SEND_PHONE_VERIFICATION, {
    onCompleted: (data) => {
      if (debug) {
          console.log ('handleSendPhoneVerification data =', data);
      }

      setSendPhoneVerificationSuscessState((prevState)=>({
        ...prevState,
        isSuscess: true,
        message: "Phone verefication sent"
      }));

    },
    onError: (error) => {
      const errorCode = error.graphQLErrors.find(
        (graphQLError) => graphQLError.extensions?.code
      )?.extensions?.code;
    
      setSendPhoneVerificationErrorState({
        hasError: true,
        message: error.message,
        code: typeof errorCode === 'string' ? errorCode : ''
      });
    
      if (debug) {
        console.log("handleSendPhoneVerification error =", error);
      }
    },
  });


  const [changePhoneNumber] = useMutation(DASHBOARD_CHANGE_PHONE, {
    onCompleted: (data) => {
      if (debug) {
        console.log('handleChangePhoneNumber data =', data);
      }
    
      setUserInfo((userInfo) => ({
        ...userInfo,
        phoneNumberInput: data.changePhoneNumber.phoneNumber
      }));
    
      refreshUserInfo();
    
      setChangePhoneSuscessState({
        isSuscess: true,
        message: "Phone was successfully changed."
      });
    },
    onError: (error) => {
      const content = error.message;
      
      setChangePhoneErrorState((prevState)=>({
        ...prevState,
        hasError: true,
        message: content
      }));

      if (debug) {
        console.log("handleSendPhoneVerification error =", error);
      }
    },
  });


  const handleSendPhoneVerification = (
    oldPhoneNumber: string,
    newPhoneNumber: string
  ) => {
    setSendPhoneVerificationErrorState({
      hasError: false,
      message: '',
      code: ''
    });
  
    setSendPhoneVerificationSuscessState({
      isSuscess: false,
      message: ''
    });
  
    sendPhoneVerification({
      variables: {
        input: {
          oldPhoneNumber,
          newPhoneNumber
        }
      },
    });
  };

  const handleChangePhoneNumber = (
    phoneNumber: string,
    token?: string
  ) => {
    setChangePhoneErrorState({
      hasError: false,
      message: ''
    });
  
    setChangePhoneSuscessState({
      isSuscess: false,
      message: 'Phone was successfully changed.'
    });
  
    changePhoneNumber({
      variables: {
        input: {
          phoneNumber,
          ...(token ? { token } : {})
        }
      },
    });
  };

  return {
    
    changePhoneErrorState,
    setChangePhoneErrorState,
    changePhoneSuscessState,
    setChangePhoneSuscessState,

    sendPhoneVerificationErrorState,
    setSendPhoneVerificationErrorState,
    sendPhoneVerificationSuscessState,
    setSendPhoneVerificationSuscessState,

    handleSendPhoneVerification,
    handleChangePhoneNumber
  }
}

